var calendarHolderGuardScreen = [null, null, null, null, null];

function CreateGuardCalendar(calendarNumber, calendarElement, dateFormat, localTime) {

    $(document).ready(function () {

        var Calendar = FullCalendar.Calendar;
        var Draggable = FullCalendar.Draggable;

        var containerEl = document.getElementById('external-events-' + calendarNumber);

        var calendarEl = document.getElementById(calendarElement);

        var today = new moment(localTime);

        var tempCalendar = new FullCalendar.Calendar(calendarEl, {
            initialView: 'dayGridMonth',
            editable: false,
            businessHours: true,
            selectable: true,
            droppable: false,
            eventTextColor: '#212529',
            nowIndicator: false,
            weekends: true,
            displayEventEnd: true,
          //  timeFormat: 'h(:mm)t',
            height: 1200,
            allDaySlot: true,
          //  width: '100%',
            headerToolbar: {
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,listMonth timeGridWeek,listWeek timeGridDay,listDay'
            },
            drop: function (info) {
            },
            dateClick: function (info) {
            },
            select: function (info) {
            },
            unselect: function (info) {
            },
            eventDrop: function (event, delta) {
            },
            eventClick: function (info) {
            },
            viewClassNames: function (arg) {
                //console.log('viewClassNames', arg.view.type);
            },
            viewDidMount: function (arg) {
                // console.log('viewDidMount', arg.view.type);
                // console.log(arg.view);
            },
            viewWillUnmount: function (arg) {
                // console.log('viewWillUnmount', arg.view.type);
            }

        });

        calendarHolderGuardScreen[calendarNumber] = tempCalendar;

     //   $('#calendarInitLoading' + calendarNumber).hide();

        setTimeout(function () {
            calendarHolderGuardScreen[calendarNumber].render();

        }, 2000);

    });



    return 1;
}

function clearGuardCalendar(calendarNumber) {
    try {
        var calendarEventsToClear = calendarHolderGuardScreen[calendarNumber].getEvents();

        if (calendarEventsToClear != null) {
            var calendarEventsToClearCount = calendarEventsToClear.length;
            for (var i = 0; i < calendarEventsToClearCount; i++) {

                if (calendarEventsToClear[i] != null) {
                    calendarEventsToClear[i].remove();
                }
            }
        }
    }
    catch (e) {

    }
}

function rerenderGuardCalendars() {
    try {

        setTimeout(function () {
            window.dispatchEvent(new Event('resize'))
        }, 1)

        for (var i = 0; i < 3; i++) {
            try {

                if (calendarHolderGuardScreen[i] != null) {
                    calendarHolderGuardScreen[i].render();

                    var currentCalendar = calendarHolderGuardScreen[i]
                    setTimeout(function () { currentCalendar.render(); }, 100);
                }

            } catch (e) {
                console.log(e);
            }
        }

        setTimeout(function () {
            window.dispatchEvent(new Event('resize'))
        }, 1)
    }
    catch { }
  
}


function PopulateGuardCalendar(calendarNumber, calendarEventDtos, guards) {

    shiftsCalendarAllGuards = guards;

    try {
        clearGuardCalendar(calendarNumber);
    }
    catch (e) {
    }

    var rawCalendarEvents = MapCalendarEvents(calendarEventDtos, 0);


    if (rawCalendarEvents != null) {
        var rawCalendarEventsCount = rawCalendarEvents.length;


        try {
            for (var j = 0; j < rawCalendarEventsCount; j++) {

                var guardName = rawCalendarEvents[j].title;

                rawCalendarEvents[j].color = getGuardColorShift(guards, guardName);

            }
        }
        catch { }
    
        var rawEventCount = rawCalendarEvents.length;

        for (var i = 0; i < rawEventCount; i++) {
            calendarHolderGuardScreen[calendarNumber].addEvent(rawCalendarEvents[i]);
        }
    }


    return 1;

}

function clearGuardCalendar(calendarNumber) {
    try {
        var calendarEventsToClear = calendarHolderGuardScreen[calendarNumber].getEvents();

        if (calendarEventsToClear != null) {
            var calendarEventsToClearCount = calendarEventsToClear.length;
            for (var i = 0; i < calendarEventsToClearCount; i++) {

                if (calendarEventsToClear[i] != null) {
                    calendarEventsToClear[i].remove();
                }
            }
        }
    }
    catch (e) {

    }
}